<template>
	<span v-if="tags?.length" class="task-tags">
		<!--		<v-chip v-for="(tag, index) of taskTags" :key="'tag'+index"
						close small :color="colorOfTag(tag)" :dark="colorByCss(tag.color)?.dark"
						@click:close="onCloseTag(tag)">
					#{{ tag.contextName }}
				</v-chip>-->
		<router-link v-for="(tag, index) of tags" :key="'tag'+index" :to="routeOf(tag)" class="__tag">
			<tag small :style="styleOfTag(tag)" :dark="isTagDark(tag)">
				{{ tag.contextName }}
			</tag>
		</router-link>
	</span>
</template>

<script>
import vp from "@/mixins/vp";
import base from "@/mixins/base";
import Config from "@/config";

export default {
	name: "task-tags",
	components: {},
	mixins: [vp, base],
	props: {
		item: {}
	},
	data: () => ({}),
	computed: {
		tags() {
			if (!this.item.tagData?.length) return null;
			//console.log("tagIds", this.item.tagIds?.length);
			//console.log("this.tags", this.tags);
			/*const tags = this.item.tagData?.filter(el => ""+el.userId === ""+this.user.id);
			tags?.sort((a, b) => {
				return a.name < b.name ? -1 : 1;
			});
			return tags;*/
			const accessibleTagIds = this.$store.state.session.area.tags?.map(el => el.id) || [];
			return this.item.tagData?.filter(el => accessibleTagIds.includes(el.contextId) || this.pinnedTags.some(p => p.id === el.contextId)
				|| Config.PUBLIC_TAG_NAMES.includes((el.contextName || "").trim().toLowerCase()));
		},
	},
	watch: {},
	methods: {
		// маршрут по тегу: на задачу внутри тега, если сейчас открыта задача, иначе на сам тег как контекст
		routeOf(tag) {
			const context = {id: tag.contextId, isTag: true};
			if ( this.isRouteSomeTask ) return this.routeOfContextTask(context, this.item);
			return this.routeOfContext(context);
		},
		/*onCloseTag(tag) {
			this.do("task/remove", {
				taskId: this.task.item.id,
				contextId: tag.contextId,
			});
		},*/
	},
}
</script>

<style lang="scss">
.task-tags {
	//background: white;
	//padding: 16px 16px 0 16px;
	display: inline-flex;
	align-items: center;
	flex-wrap: wrap;
	//gap: 4px;
	//padding: 2px;
	/*@include up($md) {
		padding: 1rem 24px 0 24px;
	}*/

	.__tag {
		display: inline-flex;
		margin: 2px;
	}

	a {
		&:hover {
			opacity: $default-hover-opacity;
		}
	}
}
</style>
